<template>
  <div id="index-exam-practice">
    <!-- 学员练习界面 -->
    <div class="centent">
      <div class="top">
        <div class="goback" @click="goback" style="margin-top: 0">
          <i class="el-icon-d-arrow-left"></i>返回
        </div>
      </div>
      <div class="title">
        {{ transitionName(tempQuestion.topicnType) }}
      </div>
      <div class="question-title">
        <span v-html="tempQuestion.questionStem"></span>
        <span class="nd"
          >（难度：<i
            :class="{
              'el-icon-star-off': true,
              'el-icon-star-on': tempQuestion.gradeOfDifficulty >= s,
            }"
            v-for="s in 5"
            :key="s"
          ></i
          >）</span
        >
      </div>
      <div class="xx" v-if="tempQuestion.topicnType == '0'">
        <!-- 选择题的选项值 -->
        <el-radio-group v-model="tempQuestion.answer">
          <el-radio
            class="itel"
            :label="qo.title"
            v-for="(qo, iii) in tempQuestion.questionOptions"
            :key="iii"
            @change="changeAnswer"
          >
            <span style="font-weight: bold">{{ qo.title }}、</span>
            <span v-html="qo.value"></span>
          </el-radio>
        </el-radio-group>
      </div>
      <div class="xx" v-if="tempQuestion.topicnType == '1'">
        <!-- 选择题的选项值 -->
        <el-checkbox-group v-model="tempQuestion.answer">
          <el-checkbox
            class="itel"
            :label="qo.title"
            v-for="(qo, iii) in tempQuestion.questionOptions"
            :key="iii"
            @change="changeAnswer"
          >
            <span style="font-weight: bold">{{ qo.title }}、</span
            ><span v-html="qo.value"></span>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="da">
        <div class="ti">【您的答案】:</div>
        <div class="tv" v-if="tempQuestion.topicnType == '0'">
          <!-- 单选 -->
          <span>{{ tempQuestion.answer }}</span>
        </div>
        <div class="tv" v-if="tempQuestion.topicnType == '1'">
          <!-- 多选 -->
          <span v-for="(item, index) in tempQuestion.answer" :key="index"
            ><span v-if="index > 0">,</span>{{ item }}</span
          >
        </div>
        <div class="tv pd" v-if="tempQuestion.topicnType == '2'">
          <!-- 填空 -->
          <div
            :class="{ li: true }"
            v-for="(item, index) in tempQuestion.answer"
            :key="index"
          >
            <div class="title">{{ item.title }}:</div>
            <div
              class="li-va ueditor"
              v-html="item.htmlValue"
              @click="editQuestionStem('填空题答案', item.htmlValue, index)"
            ></div>
          </div>
        </div>
        <div class="tv" v-if="tempQuestion.topicnType == '3'">
          <!-- 判断 -->
          <el-radio-group
            v-model="tempQuestion.answer"
            class="div-flex-center div-flex-start"
          >
            <el-radio :label="'0'">
              <i class="el-icon-check"></i>
            </el-radio>
            <el-radio :label="'1'">
              <i class="el-icon-close"></i>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="tv pd" v-if="tempQuestion.topicnType == '4'">
          <!-- 简答题 -->
          <div class="li">
            <div
              :class="{ 'li-va': true, ueditor: true, answer: false }"
              v-html="tempQuestion.answer.htmlValue"
              @click="
                editQuestionStem(
                  '简答题答案',
                  tempQuestion.answer.htmlValue,
                  -1
                )
              "
            ></div>
          </div>
        </div>
      </div>
      <div class="da1" v-if="isAnswer">
        <div class="ti">【标准答案】:</div>
        <div class="tv" v-if="tempQuestion.topicnType == '0'">
          <!-- 单选 -->
          <span>{{ tempQuestion.questionAnswer[0].value }}</span>
        </div>
        <div class="tv" v-if="tempQuestion.topicnType == '1'">
          <!-- 多选 -->
          <span
            v-for="(item, index) in tempQuestion.questionAnswer"
            :key="index"
            ><span v-if="index > 0">,</span>{{ item.value }}</span
          >
        </div>
        <div class="tv pd" v-if="tempQuestion.topicnType == '2'">
          <!-- 填空 -->
          <div
            :class="{ li: true }"
            v-for="(item, index) in tempQuestion.questionAnswer"
            :key="index"
          >
            <div class="title">{{ item.title }}:</div>
            <div
              :class="{ 'li-va': true, ueditor: !isDisable, answer: isDisable }"
              v-html="item.htmlValue"
              @click="editQuestionStem('填空题答案', item.htmlValue, index)"
            ></div>
          </div>
        </div>
        <div class="tv" v-if="tempQuestion.topicnType == '3'">
          <!-- 判断 -->
          <el-radio-group
            v-model="tempQuestion.questionAnswer[0].value"
            class="div-flex-center div-flex-start"
          >
            <el-radio :label="'0'">
              <i class="el-icon-check"></i>
            </el-radio>
            <el-radio :label="'1'">
              <i class="el-icon-close"></i>
            </el-radio>
          </el-radio-group>
        </div>
        <div class="tv pd" v-if="tempQuestion.topicnType == '4'">
          <!-- 简答题 -->
          <div class="li">
            <div
              :class="{ 'li-va': true, ueditor: true, answer: false }"
              v-html="tempQuestion.questionAnswer[0].htmlValue"
              @click="
                editQuestionStem(
                  '简答题答案',
                  tempQuestion.questionAnswer[0].htmlValue,
                  -1
                )
              "
            ></div>
          </div>
        </div>
      </div>
      <div class="perch-active"></div>
      <div class="buts">
        <div class="but" @click="chooseQuestionBut('1')">上一题</div>
        <div class="but" @click="chooseQuestionBut('0')">下一题</div>
        <div class="start">
          <div v-if="!tempQuestion.isCollect">
            <el-tooltip
              class="item"
              effect="dark"
              content="收藏"
              placement="top"
            >
              <i class="iconfont icon-shoucang" @click="changeCollect(0)"></i>
            </el-tooltip>
          </div>
          <div v-if="tempQuestion.isCollect">
            <el-tooltip
              class="item"
              effect="dark"
              content="已收藏"
              placement="top"
            >
              <i class="iconfont icon-shoucang1" @click="changeCollect(1)"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <ueditor_dialog
      v-if="ueditorDialogData.flag"
      :title="ueditorDialogData.title"
      :content="ueditorDialogData.content"
      @cancelDialog="cancelDialog"
      @makeSure="makeSure"
    ></ueditor_dialog>
  </div>
</template>

<script>
import * as questionData from "../../admin/question_bank/js/question.js";
export default {
  data() {
    return {
      isAnswer: true, // 是否答题,只有答题才显示标准答案
      flag: 0, //  0 随机练习  1 顺序练习
      subject: "", // 科目
      topicnType: "", // 题型
      tempQuestion: {},
      tempQuestionOptionIndex: 0,
      ueditorDialogData: {
        title: "",
        flag: false,
        content: "",
      },
    };
  },
  methods: {
    /**
     * 上一题下一题切换
     * flag : 1 上一题  0 下一题  为"" 刚刚进入系统,后台自行判定上次练习到哪儿
     */
    async chooseQuestionBut(flag) {
      try {
        console.log(flag);
        if (flag != "") {
          // 提交本次题目答案
          await this.submitPractice();
        }
        let requestData = {};
        if (this.flag == "0" || this.flag == 0) {
          // 随机
          requestData = {
            type: this.flag,
            flag: flag,
            subject: this.subject, // 科目ID
          };
        } else {
          //顺序
          requestData = {
            type: this.flag,
            flag: flag,
            subject: this.subject, // 科目ID
            topicnType: this.topicnType, // 题型
          };
        }
        let resultData = await this.$request({
          url: "/practice/getQuestionByPractice",
          method: "post",
          data: requestData,
        });
        let answer = "";
        switch (resultData.topicnType) {
          case "0":
          // 单选
          case "3":
            // 判断
            if (resultData.answer.length > 0) {
              answer = resultData.answer[0].value;
            } else {
              answer = "";
            }
            if (answer != "") {
              this.isAnswer = true;
            } else {
              this.isAnswer = false;
            }
            break;
          case "1":
            // 多选
            answer = [];
            if (resultData.answer.length > 0) {
              resultData.answer.forEach((element) => {
                if (element.value != "") {
                  answer.push(element.value);
                }
              });
            }
            if (answer.length > 0) {
              this.isAnswer = true;
            } else {
              this.isAnswer = false;
            }
            break;
          case "2":
            // 填空
            if (resultData.answer.length == 0) {
              answer = [{ value: "", htmlValue: "" }];
            } else {
              answer = resultData.answer;
            }
            this.isAnswer = false;
            answer.forEach((element) => {
              if (element.value != "") {
                this.isAnswer = true;
              }
            });
            break;
          case "4":
            // 简答
            if (resultData.answer.length > 0) {
              answer = resultData.answer[0];
            } else {
              answer = { value: "", htmlValue: "" };
            }
            if (answer.value != "") {
              this.isAnswer = true;
            } else {
              this.isAnswer = false;
            }
            break;

          default:
            break;
        }
        this.tempQuestion = JSON.parse(JSON.stringify(resultData));
        this.tempQuestion.answer = answer;
      } catch (error) {
        this.$message({
          message: error.message,
          type: "warning",
        });
        if (error.code == "10041") {
          this.goback();
        }
      }
    },
    /**
     * 提交本次答案
     */
    async submitPractice() {
      try {
        let requestData = {
          id: this.tempQuestion.id,
          answer: this.disposeAnswer(),
        };
        let resultData = await this.$request({
          url: "/practice/submitPractice",
          method: "post",
          data: requestData,
        });
      } catch (error) {
        this.$message({
          message: error.message,
          type: "warning",
          duration: 1000,
        });
      }
    },
    disposeAnswer() {
      let answer = [];
      let sAnswer = this.tempQuestion.answer;
      console.log(this.tempQuestion, sAnswer);
      switch (this.tempQuestion.topicnType) {
        case "0":
          // 单选
          answer = [{ value: sAnswer, htmlValue: sAnswer }];
          break;
        case "1":
          // 多选
          if (sAnswer.length == 0) {
            answer = [{ value: "", htmlValue: "" }];
          } else {
            sAnswer.forEach((element) => {
              let dd = {
                value: element,
                htmlValue: element,
              };
              answer.push(dd);
            });
          }
          break;
        case "2":
          // 填空
          answer = sAnswer;
          break;
        case "3":
          // 判断
          answer = [{ value: sAnswer, htmlValue: sAnswer }];
          break;
        case "4":
          // 简答
          answer = [sAnswer];
          break;

        default:
          break;
      }
      return answer;
    },
    /**
     * 单选/多选  选择答案
     * 渲染界面是否显示以做
     */
    async changeAnswer() {
      let isAnswer = false;
      if (this.tempQuestion.topicnType == "4") {
        // 简答
        if (
          this.tempQuestion.answer.value &&
          this.tempQuestion.answer.value != ""
        ) {
          isAnswer = true;
        }
      } else if (this.tempQuestion.topicnType == "2") {
        //  填空
        if (this.tempQuestion.answer.length > 0) {
          isAnswer = true;
        }
      } else {
        if (this.tempQuestion.answer != "") {
          isAnswer = true;
        }
      }
      this.tempQuestion.isAnswer = isAnswer;
      if (this.tempQuestion.topicnType != "1") {
        // 多选只能点击上一题/下一题时提交答案
        await this.submitPractice();
        await this.chooseQuestionBut("");
      }
    },
    /**
     * 编辑题干
     */
    editQuestionStem(title, content, index) {
      this.tempQuestionOptionIndex = index;
      this.ueditorDialogData.title = title;
      this.ueditorDialogData.content = content;
      this.ueditorDialogData.flag = true;
    },
    /**
     * 确认编辑框内容
     */
    makeSure(content) {
      console.log("编辑器返回的值", content);
      let data = questionData.questionItemReset(content.content);
      let text = questionData.questionItemReset(content.text);
      if (this.ueditorDialogData.title == "填空题答案") {
        // 编辑选项
        if (data.length > 0) {
          this.$message.error("答案中不可有填空");
          return;
        }
        if (this.tempQuestionOptionIndex >= 0) {
          // 找到对应的选项的值
          this.tempQuestion.answer[this.tempQuestionOptionIndex].htmlValue =
            content.content;
          this.tempQuestion.answer[this.tempQuestionOptionIndex].value =
            content.text;
        }
      } else if (this.ueditorDialogData.title == "简答题答案") {
        if (data.length > 0) {
          this.$message.error("答案中不可有填空");
          return;
        }
        this.tempQuestion.answer.value = content.text;
        this.tempQuestion.answer.htmlValue = content.content;
      }
      this.cancelDialog();
      this.changeAnswer();
    },
    /**
     * 添加或取消收藏
     */
    async changeCollect(flag) {
      try {
        let requestData = {};
        let resultData = {};
        if (flag == 0) {
          // 添加收藏
          requestData = {
            questionId: this.tempQuestion.qId,
            answer: this.disposeAnswer(),
          };
          resultData = await this.$request({
            url: "/errCollect/addErrCollect",
            method: "post",
            data: requestData,
          });
          this.$message({
            message: "收藏成功!!!",
            type: "warning",
          });
          await this.chooseQuestionBut("");
        } else {
          requestData = {
            id: this.tempQuestion.collectId,
            flag: "collect",
          };
          resultData = await this.$request({
            url: "/errCollect/removeErrCollectById",
            method: "post",
            data: requestData,
          });
          this.$message({
            message: "已取消!!!",
            type: "warning",
          });
          await this.chooseQuestionBut("");
        }
      } catch (error) {
        this.$message({
          message: error.message,
          type: "warning",
        });
      }
    },
    /**
     * 显示题型(文字)
     */
    transitionName(type) {
      return questionData.initTableValue("topic", type);
    },
    /**
     * 关闭编辑框
     */
    cancelDialog() {
      this.ueditorDialogData.flag = false;
    },
    /**
     * 返回上一页
     */
    goback() {
      this.$router.back();
    },
  },
  async mounted() {
    this.flag = this.$route.query.flag; // 0 随机练习  1 顺序练习
    this.subject = this.$route.query.subject; // 科目
    this.topicnType = this.$route.query.topicnType; // 题型
    await this.chooseQuestionBut("");
  },
};
</script>

<style lang="less" scoped>
#index-exam-practice {
  width: 100%;
  height: 100%;
  display: flex;
  padding: 10px 15px;
  box-sizing: border-box;
  > .centent {
    width: 0;
    flex: 1;
    height: 100%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    padding: 10px;
    box-sizing: border-box;
    border-radius: 8px;
    > .title {
      width: 100%;
      height: 40px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      font-size: 16px;
      font-weight: bold;
    }
    > .question-title {
      width: 100%;
      height: auto;
      line-height: 30px;
      display: flex;
      align-items: center;
      > .nd {
        margin-left: 10px;
        font-size: 14px;

        .el-icon-star-off {
          font-size: 15px;
          color: #e9e9e9;
        }
        .el-icon-star-on {
          color: #ffe710;
          font-size: 17px;
        }
      }
    }
    > .xx {
      width: 100%;
      height: auto;
      display: flex;
      flex-direction: column;
      padding: 0 20px;
      box-sizing: border-box;
      margin-top: 15px;
      .itel {
        width: 100%;
        height: auto;
        line-height: 30px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 5px;
        font-size: 15px;
        /deep/ .el-radio__label {
          display: flex;
        }
      }
    }
    > .da,
    > .da1 {
      width: 100%;
      height: auto;
      display: flex;
      padding: 0 20px;
      box-sizing: border-box;
      margin-top: 20px;
      > .ti {
        width: auto;
        height: 40px;
        margin-right: 8px;
        font-size: 15px;
        font-weight: bold;
        margin: 10px 0;
        display: flex;
        align-items: center;
      }
      > .tv {
        width: 0;
        flex: 1;
        height: auto;
        min-height: 40px;
        display: flex;
        align-items: center;
        margin-left: 10px;
      }
      > .pd {
        flex-direction: column;
        > .li {
          width: 100%;
          height: 40px;
          display: flex;
          align-items: center;
          margin: 10px 0;
          .li-va {
            width: 0;
            height: 100%;
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 0 10px;
            box-sizing: border-box;
          }
        }
      }
    }
    > .da1 {
      margin-top: 0px;
    }
    > .buts {
      width: 100%;
      height: 80px;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      padding: 0 10px;
      box-sizing: border-box;
      > .but {
        width: auto;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 70px;
        box-sizing: border-box;
        margin: 0 15px;
        background-color: @baseColor;
        color: #fff;
        cursor: pointer;
      }
      > .start {
        width: 50px;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          font-size: 23px;
          cursor: pointer;
        }
        .icon-shoucang1 {
          color: #ff7f35;
        }
      }
    }
  }
  .ueditor {
    border: 1px solid @baseColor;
    margin-left: 10px;
    cursor: pointer;
    padding: 5px;
    box-sizing: border-box;
  }

  /deep/ .gapfilling-span {
    /* background-color: antiquewhite; */
    display: inline-block;
    /* text-decoration: underline; */
    border-bottom: 1px solid #444;
    padding: 0 30px;
    margin: 0 5px;
  }
  .el-icon-star-off {
    font-size: 25px;
    color: #eeeeee;
    cursor: pointer;
  }
  .el-icon-star-on {
    color: #ffe710;
    font-size: 25px;
    cursor: pointer;
  }
  // .el-radio-button__inner,
  // .el-radio-group {
  //   display: flex;
  //   align-items: center;
  // }
  /deep/.el-checkbox__label {
    display: flex;
  }
}
</style>